module.exports = {"title":"Week 3: Broken Code","body":"<p>We had our first in-person meeting with Dr. Sirovic, where we made a trip down to the Scripps Institute of Oceanography campus.  We received the code implementing the current CNN code and got a further in-depth description of what we would be working on.  We came up with a rough timeline, and gave the overview presentation that we planned last week.  Lastly, we began working on running the code we were given in its existing state.</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./process/week-3/index.md
// module id = 494
// module chunks = 0